import type { HelpFile } from '../../types/help'
import { RegistryHelpIconPortalTestIds } from '../../../testids/RegistryHelpIconPortalTestIds'

export const registryHelpIconPortalHelp: HelpFile = {
  texts: {
    [RegistryHelpIconPortalTestIds.helpIconButton]: null,
  },
}
